import styled from 'styled-components';
import {GlobalColors, GlobalFonts} from '../../globals';

export const ContCreateTechSection = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px 0;
  background: #F5F5F5;
  max-width: 1440px;
  margin: 0 auto;

  @media(min-width: 300px) and (max-width: 767px){
    padding: 60px 0;
  }
`;

export const CreateTechContent = styled.div`
  width: 85%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 60px;
  max-width: 1440px;
  margin: 0 auto;

  @media(min-width: 300px) and (max-width: 1023px){
    flex-direction: column;
    width: 90%;
    gap: 40px;
  }
`;

export const ImageSection = styled.div`
  flex: 0 0 45%;
  display: flex;
  align-items: center;
  justify-content: center;

  @media(min-width: 300px) and (max-width: 1023px){
    flex: 1;
    width: 100%;
  }
`;

export const MainImage = styled.img`
  width: 100%;
  max-width: 500px;
  height: auto;
  border-radius: 24px;
  object-fit: cover;

  @media(min-width: 300px) and (max-width: 767px){
    max-width: 100%;
  }
`;

export const TextSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

  @media(min-width: 300px) and (max-width: 1023px){
    align-items: center;
    text-align: center;
  }
`;

export const TitleSection = styled.h2`
  font-family: ${GlobalFonts.fontBold};
  font-size: 34px;
  line-height: 44px;
  color: ${GlobalColors.colorPrimaryDark};
  margin-bottom: 10px;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 28px;
    line-height: 36px;
  }
`;

export const DescSection = styled.p`
  font-family: ${GlobalFonts.fontRegular};
  font-size: 20px;
  line-height: 24px;
  color: ${GlobalColors.colorText};
  margin-bottom: 40px;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 15px;
    line-height: 22px;
    margin-bottom: 30px;
  }
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  width: 100%;

  @media(min-width: 300px) and (max-width: 767px){
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
`;

export const TechCard = styled.div`
  background: #D0E5FD;
  border-radius: 12px;
  padding: 20px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  transition: all 0.3s ease;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  }

  @media(min-width: 300px) and (max-width: 767px){
    padding: 15px 12px;
    gap: 12px;
  }
`;

export const CardIcon = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media(min-width: 300px) and (max-width: 767px){
    width: 35px;
    height: 35px;
  }
`;

export const CardText = styled.span`
  font-family: ${GlobalFonts.fontBold};
  font-size: 18px;
  line-height: 24px;

  @media(min-width: 300px) and (max-width: 767px){
    font-size: 16px;
    line-height: 22px;
  }
`;
